const script = document.createElement('script');
script.src = 'https://umami.wahaha.com.cn/script.js';
script.setAttribute('data-website-id', '7e47229c-040e-4873-8f59-fb9c448cb98b');
script.async = true;
document.getElementsByTagName('head')[0].appendChild(script);
